const url = 'https://services.mybcapps.com/bc-sf-filter/filter?_=pf&shop=lions-pride-plus.myshopify.com&build_filter_tree=true';

console.log('test');

fetch(url).then(response => response.json())
.then(data => {
  var filterTree = data.filter.options
  
  var filterSize = filterTree.filter(obj => {
    return obj.filterType === "opt_size"
  })
  
  console.log(filterSize[0].manualValues)
  
  var filterSizeValues = filterSize[0].manualValues

  var counter = 0;

  var container = document.querySelector('.product__variants--radio');
  for (var size in filterSizeValues) {
    var option = container.querySelector('input[value="'+ filterSizeValues[size] +'"]');
    if(option != null){
      option.classList.add('order-' + counter );
      container.querySelector('label[for="'+ option.id +'"]').classList.add('order-' + counter );
      counter++
    }
  }
});